import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.793 19.2a1.72 1.72 0 0 1-1.268-.529A1.74 1.74 0 0 1 0 17.401V6q0-.744.53-1.272A1.73 1.73 0 0 1 1.8 4.2h1.8v-.4q0-1.5 1.013-2.65T7.2 0q1.5 0 2.55 1.05T10.8 3.6v.6h1.8q.743 0 1.271.529.53.528.53 1.271v11.4q0 .743-.53 1.271a1.74 1.74 0 0 1-1.272.53H1.793zm.007-1.8h10.8V6h-1.8v1.5a.87.87 0 0 1-.257.641.86.86 0 0 1-.638.26.88.88 0 0 1-.643-.26.86.86 0 0 1-.262-.64V6H5.4v1.5a.87.87 0 0 1-.257.64.86.86 0 0 1-.638.26.88.88 0 0 1-.642-.26.86.86 0 0 1-.263-.64V6H1.8zM5.4 4.2H9v-.6a1.73 1.73 0 0 0-.53-1.271A1.74 1.74 0 0 0 7.195 1.8q-.745 0-1.27.529A1.74 1.74 0 0 0 5.4 3.6z"
    }, null, -1)
  ]))]))
}
export default { render: render }